import React from 'react';
import Modal from 'react-modal';
import closeIcon from '../../../assets/images/close-icon.svg';
import './index.scss';

export interface IAppModal {
  isOpen: boolean;
  onClose: (e: any) => void;
  hideCloseIcon?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'custom';
  children?: React.ReactNode;
  customClassName?: string;
  adjustToContent?: boolean;
  maxWidth?: string | number;
}

const AppModal = ({ isOpen, onClose, size = 'md', children, hideCloseIcon = false, customClassName, adjustToContent = false, maxWidth }: IAppModal) => {

  // Passed as a CSS variable so it can override the !important max-widths on the size/adjust-to-content classes
  const contentStyle = maxWidth
    ? ({ '--app-modal-max-width': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth } as React.CSSProperties)
    : {};

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName={`modalOverlay`}
      className={`modalContent ${size}${adjustToContent ? ' adjust-to-content' : ''}${maxWidth ? ' has-max-width' : ''} ${customClassName ? customClassName : ''}`}
      style={{ content: contentStyle, overlay: {} }}
    >
      {!hideCloseIcon && (
        <button
          type="button"
          aria-label="Close"
          className="tw-absolute tw-top-0 tw-right-0 tw-cursor-pointer tw-z-10 tw-inline-flex tw-items-center tw-justify-center tw-w-11 tw-h-11 tw-bg-transparent tw-border-0 tw-p-0"
          onClick={onClose}
        >
          <img src={closeIcon} alt="" className="tw-w-6" />
        </button>
      )}
      {children}
    </Modal>
  );

}

export default AppModal;